module.exports = __webpack_public_path__ + "img/newCand-download-icon.8faa5f67.svg";